import React, { useContext, useRef }  from "react";
import { SystemOperation, SystemPageType } from "../../../../Model/SystemModels";
import { ListHeaderEntry } from "../../../Common/Template/List/ListHeaderEntry";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { ContainerType, PageDefinitionContainer } from "../../../Common/Template/PageDefinitionContainer";
import { t } from "i18next";
import { PartnerInformationContext } from "../../../../ApplicationCode/Partner/PartnerInformationContext";
import { PartnerItem } from "../../../../Model/PartnerModels";
import { PartnerItemCard } from "../PartnerItemCard/PartnerItemCard";

export const PartnerItemList : React.FC = () => {
    const cardRef = useRef<PageContainerBase>(null);
    const partnerInfoContext = useContext(PartnerInformationContext);

    const buildListEndpoint = () => "/odata/partner/item?$filter=partnerId eq "+partnerInfoContext.partner.id;
    
    const setNewRecord = () => {
        let newRecord = new PartnerItem();
        newRecord.partnerId = partnerInfoContext.partner.id;
        cardRef.current?.setRecord(newRecord);
        cardRef.current?.openPage(SystemOperation.Insert);
    }

    return (
        <>
            <PageContainer endpoint={buildListEndpoint()} pageType={SystemPageType.List} title={t('partnerCenter:partnerItemList:title')!} cardRef={cardRef} backAllowed insertAllowed updateAllowed deleteAllowed onNewRecord={setNewRecord}>
                <PageDefinitionContainer type={ContainerType.Action}></PageDefinitionContainer>
                <PageDefinitionContainer type={ContainerType.PageStructure}>
                    <ListHeaderEntry name={t('partnerCenter:partnerItemList:fields:itemId')!} fieldName="itemId" minWidth={150} maxWidth={250} />
                    <ListHeaderEntry name={t('partnerCenter:partnerItemList:fields:itemDescription')!} fieldName="itemDescription" minWidth={600} maxWidth={700} />
                    <ListHeaderEntry name={t('partnerCenter:partnerItemList:fields:partnerItemNo')!} fieldName="partnerItemNo" minWidth={600} maxWidth={700} />
                </PageDefinitionContainer>
            </PageContainer>
            <PartnerItemCard ref={cardRef} />
        </>
    );
}